export const categories = [
  {
    id: "latest-address",
    name: "最新地址",
    slug: "latest-address",
    icon: "ri-link-m",
    description: "www91最新官方入口地址，实时更新确保访问畅通无阻",
  },
  {
    id: "access-guide",
    name: "访问指南",
    slug: "access-guide",
    icon: "ri-guide-fill",
    description: "详细的www91访问教程，帮助新用户快速上手",
  },
  {
    id: "faq",
    name: "常见问题",
    slug: "faq",
    icon: "ri-question-answer-line",
    description: "关于www91使用过程中常见问题的详细解答",
  },
  {
    id: "security-tips",
    name: "安全须知",
    slug: "security-tips",
    icon: "ri-shield-check-line",
    description: "保障账号安全与网络安全的重要建议",
  },
  {
    id: "updates",
    name: "平台动态",
    slug: "updates",
    icon: "ri-notification-3-line",
    description: "www91平台最新公告、更新与维护通知",
  },
  {
    id: "tutorials",
    name: "使用教程",
    slug: "tutorials",
    icon: "ri-book-open-line",
    description: "从注册到高级功能，全面的www91使用教程",
  },
];

export const articles = [
  {
    id: 1,
    categoryId: "latest-address",
    title: "www91最新官方入口地址（2026年8月更新）",
    slug: "latest-official-address-2026-08",
    summary: "本文提供www91最新官方入口地址，确保您能安全稳定地访问平台。请收藏本页面以便随时获取最新地址。",
    content: `## www91最新官方入口地址\n\nwww91作为广受用户信赖的网络平台，始终致力于为用户提供安全、稳定、便捷的访问体验。为了应对网络环境的变化，我们定期更新官方入口地址，确保用户能够顺利访问。\n\n### 当前最新地址\n\n请通过以下官方入口访问www91：**[最新入口地址将在官方确认后第一时间更新]**\n\n### 为什么需要更新地址\n\n网络环境的复杂性决定了我们需要定期更新访问入口，以确保所有用户都能顺畅地访问平台。我们建议用户收藏本导航页面，以获取最新的官方地址信息。\n\n### 如何确认是否为官方入口\n\n1. 核对域名信息是否与官方公布一致\n2. 查看页面底部是否有官方认证标识\n3. 通过本导航站提供的入口访问最为安全\n\n### 备用访问方式\n\n如主入口暂时无法访问，您可以通过以下备用方式尝试：\n- 使用本站提供的备用域名\n- 联系官方客服获取最新地址\n- 关注官方社交媒体账号获取通知`,
    publishDate: "2026-08-10",
    readTime: "3分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20website%20navigation%20concept%20with%20clean%20geometric%20shapes%20in%20warm%20golden%20and%20cream%20tones%2C%20abstract%20internet%20connection%20visualization%2C%20soft%20gradient%20background%2C%20professional%20tech%20aesthetic%2C%20high%20quality%20editorial%20style&width=800&height=480&seq=article-thumb-01&orientation=landscape",
  },
  {
    id: 2,
    categoryId: "access-guide",
    title: "www91新用户注册与登录完整指南",
    slug: "new-user-registration-guide",
    summary: "一步一步教您完成www91的注册与登录流程，附带常见问题解决方案，让您快速开始使用。",
    content: `## 新用户注册与登录指南\n\n### 注册步骤\n\n1. 访问www91官方入口\n2. 点击页面右上角的「注册」按钮\n3. 填写手机号或邮箱地址\n4. 设置安全密码\n5. 输入验证码完成验证\n6. 阅读并同意用户协议\n7. 点击「完成注册」\n\n### 登录流程\n\n完成注册后，您可以使用以下方式登录：\n- 账号密码登录\n- 手机验证码登录\n- 第三方账号授权登录\n\n### 遇到问题怎么办\n\n如果您在注册或登录过程中遇到任何问题，请参考以下解决方案：\n- 忘记密码：点击登录页面的「忘记密码」进行重置\n- 收不到验证码：检查手机信号或邮箱垃圾箱\n- 账号被锁定：联系客服协助解锁`,
    publishDate: "2026-08-08",
    readTime: "5分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20user%20registration%20interface%20concept%20with%20warm%20neutral%20tones%2C%20abstract%20geometric%20shapes%20representing%20user%20onboarding%2C%20soft%20cream%20background%20with%20subtle%20golden%20accents%2C%20modern%20UI%20design%20aesthetic&width=800&height=480&seq=article-thumb-02&orientation=landscape",
  },
  {
    id: 3,
    categoryId: "security-tips",
    title: "www91账号安全防护最佳实践",
    slug: "account-security-best-practices",
    summary: "了解如何保护您的www91账号安全，包括密码管理、双重认证和安全上网习惯。",
    content: `## 账号安全防护指南\n\n### 密码安全\n\n- 使用至少12位的强密码\n- 包含大小写字母、数字和特殊字符\n- 避免使用生日、手机号等个人信息\n- 定期更换密码\n- 不同平台使用不同密码\n\n### 双重认证\n\n强烈建议开启双重认证功能：\n1. 进入账号设置页面\n2. 选择「安全设置」\n3. 开启「双重认证」\n4. 按照提示完成绑定\n\n### 安全上网提醒\n\n- 仅通过官方入口访问\n- 不要在公共WiFi下登录\n- 使用完毕后及时退出\n- 警惕钓鱼网站和虚假客服`,
    publishDate: "2026-08-05",
    readTime: "4分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Abstract%20cybersecurity%20concept%20with%20shield%20symbol%20and%20digital%20patterns%20in%20warm%20gold%20and%20soft%20cream%20tones%2C%20minimalist%20geometric%20design%2C%20professional%20tech%20security%20aesthetic%2C%20clean%20composition&width=800&height=480&seq=article-thumb-03&orientation=landscape",
  },
  {
    id: 4,
    categoryId: "latest-address",
    title: "www91备用域名汇总与使用说明",
    slug: "backup-domains-guide",
    summary: "收录www91所有官方备用域名，帮助您在主入口不可用时通过备用渠道访问平台。",
    content: `## 备用域名使用说明\n\n### 什么是备用域名\n\n备用域名是www91官方提供的替代访问入口，当主域名因网络波动或其他原因暂时无法访问时，您可以通过备用域名继续使用平台服务。\n\n### 备用域名列表\n\n以下为www91官方备用域名（持续更新中）：\n- 备用域名一：[待官方确认]\n- 备用域名二：[待官方确认]\n- 备用域名三：[待官方确认]\n\n### 使用注意事项\n\n1. 仅使用本站公布官方备用域名\n2. 不要点击来路不明的链接\n3. 访问前确认域名拼写正确\n4. 遇到可疑域名请及时反馈`,
    publishDate: "2026-08-03",
    readTime: "3分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Multiple%20connected%20nodes%20and%20pathways%20in%20abstract%20network%20visualization%2C%20warm%20golden%20and%20cream%20color%20palette%2C%20minimalist%20geometric%20design%2C%20clean%20professional%20aesthetic%2C%20soft%20gradient%20background&width=800&height=480&seq=article-thumb-04&orientation=landscape",
  },
  {
    id: 5,
    categoryId: "tutorials",
    title: "www91平台功能全景介绍",
    slug: "platform-features-overview",
    summary: "全面了解www91平台的所有核心功能，帮助您充分利用平台资源，提升使用体验。",
    content: `## 平台功能全景介绍\n\n### 核心功能模块\n\nwww91平台提供丰富的功能服务，以下是主要功能模块的介绍：\n\n#### 内容浏览\n- 海量优质内容资源\n- 智能推荐算法\n- 个性化内容定制\n\n#### 社区互动\n- 用户评论与交流\n- 内容分享功能\n- 兴趣小组\n\n#### 个人中心\n- 浏览历史记录\n- 收藏管理\n- 个人资料设置\n\n### 高级功能\n\n- 会员专属权益\n- 内容下载服务\n- 优先客服支持`,
    publishDate: "2026-07-28",
    readTime: "6分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20dashboard%20interface%20concept%20with%20clean%20layout%20and%20warm%20neutral%20tones%2C%20abstract%20data%20visualization%2C%20minimalist%20design%20with%20golden%20accent%20elements%2C%20professional%20software%20platform%20aesthetic&width=800&height=480&seq=article-thumb-05&orientation=landscape",
  },
  {
    id: 6,
    categoryId: "faq",
    title: "www91常见问题汇总（2026年最新版）",
    slug: "faq-collection-2026",
    summary: "汇总用户最常问的问题，涵盖访问、注册、使用、安全等各个方面。",
    content: `## 常见问题汇总\n\n### 访问相关\n\n**Q: 为什么打不开www91？**\nA: 可能的原因包括网络问题、域名更新、浏览器缓存等。请尝试清除缓存或使用本站提供的最新地址。\n\n**Q: 访问速度慢怎么办？**\nA: 建议检查网络连接，尝试切换网络环境，或使用备用域名访问。\n\n### 注册相关\n\n**Q: 注册需要哪些信息？**\nA: 通常需要手机号或邮箱、设置密码即可完成注册。\n\n**Q: 可以不注册使用吗？**\nA: 部分内容可以浏览，但完整功能需要注册账号。\n\n### 安全相关\n\n**Q: 如何确认网站真实性？**\nA: 通过本站提供的官方入口访问，或核对官方公布的域名信息。`,
    publishDate: "2026-07-25",
    readTime: "4分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Abstract%20question%20mark%20and%20answer%20concept%20in%20minimalist%20geometric%20style%2C%20warm%20cream%20and%20golden%20color%20palette%2C%20soft%20gradient%20background%2C%20clean%20professional%20design%2C%20help%20and%20support%20visual&width=800&height=480&seq=article-thumb-06&orientation=landscape",
  },
  {
    id: 7,
    categoryId: "updates",
    title: "www91平台2026年8月维护公告",
    slug: "maintenance-notice-2026-08",
    summary: "www91平台计划于2026年8月进行系统维护升级，届时部分功能可能暂时不可用，请提前做好准备。",
    content: `## 系统维护公告\n\n### 维护时间\n\n计划维护时间：2026年8月15日 02:00 - 06:00（预计4小时）\n\n### 影响范围\n\n维护期间以下功能可能受到影响：\n- 用户登录与注册\n- 内容上传功能\n- 部分页面加载速度\n\n### 维护内容\n\n本次维护主要进行以下升级：\n- 服务器性能优化\n- 安全防护升级\n- 用户体验改进\n- 新功能预部署\n\n### 注意事项\n\n请用户在维护开始前保存好正在进行的工作内容。维护结束后所有功能将恢复正常。感谢您的理解与支持！`,
    publishDate: "2026-08-01",
    readTime: "2分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Server%20maintenance%20and%20update%20concept%20with%20abstract%20geometric%20shapes%2C%20warm%20amber%20and%20cream%20color%20scheme%2C%20minimalist%20design%2C%20professional%20tech%20announcement%20visual%2C%20soft%20gradient&width=800&height=480&seq=article-thumb-07&orientation=landscape",
  },
  {
    id: 8,
    categoryId: "tutorials",
    title: "如何设置www91消息通知偏好",
    slug: "notification-settings-tutorial",
    summary: "个性化定制您的消息通知偏好，不错过重要信息，同时避免不必要的打扰。",
    content: `## 消息通知设置教程\n\n### 通知类型\n\nwww91提供多种通知类型供您选择：\n- 系统通知\n- 内容更新提醒\n- 互动消息\n- 活动推送\n\n### 设置步骤\n\n1. 登录后进入个人中心\n2. 点击「通知设置」\n3. 根据需求开启或关闭各类通知\n4. 设置免打扰时段\n5. 保存设置\n\n### 最佳实践\n\n建议保留系统通知和重要消息提醒开启，将营销推送设置为按需接收，既能及时获取重要信息，又不会受到过多打扰。`,
    publishDate: "2026-07-20",
    readTime: "3分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Notification%20settings%20interface%20concept%20with%20toggle%20switches%20and%20clean%20layout%2C%20warm%20neutral%20color%20palette%2C%20minimalist%20UI%20design%2C%20soft%20cream%20background%20with%20golden%20accents&width=800&height=480&seq=article-thumb-08&orientation=landscape",
  },
];

export const faqs = [
  {
    question: "www91是什么？",
    answer: "www91是广受用户信赖的网络平台，提供丰富的内容和服务。本导航站旨在帮助用户快速找到www91的正确官方入口，确保安全稳定访问。",
  },
  {
    question: "如何获取www91最新官方入口地址？",
    answer: "您可以通过收藏本站来获取www91最新官方入口地址。我们会在首页显著位置展示最新地址，并实时更新以确保信息的准确性。建议将本站添加到浏览器书签，方便随时访问。",
  },
  {
    question: "www91访问不了怎么办？",
    answer: "如果您无法访问www91，请尝试以下方法：1）清除浏览器缓存和Cookie；2）尝试使用本站提供的备用域名；3）切换网络环境（如从WiFi切换到移动数据）；4）检查是否有防火墙或安全软件拦截。如仍无法解决，请关注本站获取最新公告。",
  },
  {
    question: "如何确认访问的是真正的www91官方网站？",
    answer: "为确保安全，请务必通过本站提供的官方入口访问www91。同时注意核对以下几点：1）网址拼写是否正确；2）页面是否有官方认证标识；3）是否要求输入敏感信息。不要轻信搜索引擎广告或来路不明的链接。",
  },
  {
    question: "www91是否需要注册才能使用？",
    answer: "www91部分内容可以无需注册直接浏览，但要使用完整功能（如评论、收藏、个性化推荐等），则需要注册账号。注册过程简单快捷，只需提供基本信息即可完成。",
  },
  {
    question: "本站与www91是什么关系？",
    answer: "本站是www91官方认可的导航站点，专门为用户提供www91最新官方入口地址、访问指南和常见问题解答。我们致力于帮助用户安全、便捷地访问www91平台。本站不存储用户数据，仅提供导航和资讯服务。",
  },
  {
    question: "www91的备用域名是什么？",
    answer: "www91设有多个备用域名以应对主域名暂时不可用的情况。备用域名列表会定期更新，请关注本站「最新地址」栏目获取完整的备用域名信息。请勿使用非官方公布的域名。",
  },
  {
    question: "如何联系www91官方客服？",
    answer: "您可以通过www91平台内的在线客服、官方邮箱或社交媒体账号联系客服团队。关于具体的联系方式，请查看本站「关于我们」页面的联系信息部分。",
  },
];